module.exports = __webpack_public_path__ + "static/media/india.fc99589a.png";